export default class PageSource {
  constructor(url) {
    this.url = url;
  }

  get() {
    if(this.url.hostname && this.url.hostname.indexOf("vidio") === -1) {
      return this.url.hostname;
    } else if(this.url.hostname && this.url.hostname.indexOf("vidio") !== -1) {
      if(this.url.pathname.indexOf("/watch/") !== -1) {
        return "watch now";
      } else if(this.url.pathname.indexOf("/search/") !== -1) {
        return "search";
      } else if(this.url.pathname.indexOf("/categories/") !== -1) {
        return "categories_" + this.categoryName(this.url.pathname);
      } else {
        return this.url.pathname;
      }
    } else {
      return "";
    }
  }

  categoryName(pathname) {
    var categoryPath = pathname.split("/");
    categoryPath = categoryPath[categoryPath.length - 1];
    return categoryPath.replace(/[0-9]+-/, "").toUpperCase();
  }
}
